<template>
	<div :class="{ 'letterDesign': isLetter, 'outfitsDesign': !isLetter }" :style="outerStyle" class="outfitmodal">
		<div class="modal-wrapper" :style="{ width: modalWidth + 'px' }">
			<div class="modal-buttons flex flex-column">
				<button
                    v-if="isLetter"
                    class="confirm-button bg-pink generalButton"
                    v-on:click="$emit('completeOrder')">
                    Complete styling
                </button>
                <button v-else
                    class="confirm-button bg-pink generalButton"
                    v-on:click="$emit('completeOrder')">
                    Confirm
                </button>
				<button
					v-if="isLetter"
					class="edit-button bg-dark-grey generalButton"
					v-bind:class="{'bg-sky-blue': changedLetter}"
					v-on:click="$emit('saveLetter')">
						SAVE LETTER
				</button>
                <button
					v-if="isLetter"
					class="edit-button bg-dark-grey generalButton"
					v-bind:class="{'bg-warning': changedLetter}"
					v-on:click="$emit('resetLetter')">
						Reset
				</button>
				<button class="cancel-button bg-dark-grey generalButton" v-on:click="$emit('close')">CANCEL</button>
                <button
                    v-if="isLetter"
                    class="confirm-button feedbacksummaryButton generalButton"
                    style="background: #d59f28; margin-top: 10px;"
                    v-on:click="showFeedbackSummaryModal">
                    FEEDBACK
                </button>
			</div>
			<div class="modal-content">
				<slot />
			</div>
		</div>

        <modal name="feedbackSummaryModal" class="feedbackSummaryModalClass letter" v-if="feedbackSummaryModalShow" @close="feedbackSummaryModalShow = false">
            <div v-click-outside="() => { feedbackSummaryModalShow = false }">
                <FeedbackSummaryModal :summary="feedbackSummary" :survey="survey" :styling="styling" type="customer" />
            </div>
        </modal>
	</div>
</template>

<script>

import FeedbackSummaryModal from '@/components/styling-process/FeedbackSummaryModal'

let loader;
export default {
  name: 'OutfitModal',
  props: {
    modalWidth: {
      type: Number,
      default: 700
    },
    isLetter: {
	    type: Boolean,
	    default: false
    },
    changedLetter: {
	    type: Boolean,
	    default: false
    },
    feedbackSummary:{
        type: String,
        default: ""
    },
    survey: {
        type: Object,
        default: null
    },
    styling: {
        type: Object,
        default: null
    },
  },

  components: {
      FeedbackSummaryModal,
    },
  data () {
    return {
	  zoom: 100,
      feedbackSummaryModalShow: false,
    }
  },
  mounted () {
    this.autoSetZoom()
    window.addEventListener('resize', () => {
      this.autoSetZoom()
    })
  },
  computed: {
    outerStyle () {
      return 'zoom: ' + this.zoom + '%;'
    }
  },
  methods: {
    showFeedbackSummaryModal () {
        loader = this.$loading.show()
        setTimeout(() => {
            loader.hide()
            this.feedbackSummaryModalShow = true
        }, 100)
    },
        
    autoSetZoom () {
	  var modalMargin = 300
	  if (this.modalWidth + modalMargin > window.innerWidth) {
        var screenWidth = window.innerWidth - modalMargin
        var zoomSuggest = Math.round((screenWidth / this.modalWidth) * 100)
      	this.zoom = zoomSuggest
	  }
    }
  }
}
</script>

<style lang="less" scoped>

.letterDesign{
    zoom: 65% !important;

    .modal-wrapper{
        width: auto !important;
        padding-right: 100px;
    
        .modal-buttons{
            right: 0px;
            @media screen and (min-width: 1100px) {
                right: -60px;
            }
            .generalButton{
                @media screen and (min-width: 1100px) {
                    width: 150px;
                    height: 60px;
                    padding: 10px 15px;
                    font-size: 17px;
                }
            }
        }
        .modal-content{
            max-height: none;
            height: fit-content;

            @media screen and (max-width: 1500px) {
                height: 120vh;
            }
        }
    }
}

.outfitsDesign{
    .modal-wrapper{    
        .modal-buttons{
            @media screen and (min-width: 1100px) {
                right: -130px;
            }
            .generalButton{
                @media screen and (min-width: 1100px) {
                    width: 120px;
                    height: 50px;
                    padding: 10px 15px;
                    font-size: 14px;
                }
            }
        }
   }
}
</style>
